<template>
  <div class="recommend_info">
    <!-- <div class="head">
      <van-icon class="back_btn" name="arrow-left" @click="goBack" />
      <div class="title">
        老带新推荐
      </div>
    </div> -->
    <div class="bg">
      <div class="tips">
        <div class="name">
          {{ this.$route.params.allname }}
        </div>
        <div class="phone">{{ this.$route.params.tel }}</div>
      </div>
    </div>

    <div class="main">
      <div class="table">
        <van-form
          @submit="onSubmit"
          input-align="right"
          error-message-align="right"
          validate-trigger="onChange"
          scroll-to-error
        >
          <div class="must">
            <van-field
              v-if="this.$route.params.type == 3 ? false : true"
              readonly
              clickable
              name="timeValue"
              :value="timeValue"
              label="维护时间"
              placeholder="请选择"
              @click="showCalendar = true"
              input-align="right"
              right-icon="arrow"
              :required="true"
              :rules="[
                { required: true, validator, message: '请选择维护时间' },
              ]"
            />

            <van-calendar
              title="选择时间"
              v-model="showCalendar"
              @confirm="onConfirm"
            />
            <div
              class="line"
              v-if="this.$route.params.type == 3 ? false : true"
            ></div>
            <van-field
              v-if="this.$route.params.type == 3 ? false : true"
              readonly
              clickable
              name="safeguard"
              :value="maintain"
              label="维护方式"
              placeholder="请选择"
              @click="showGuard = true"
              input-align="right"
              right-icon="arrow"
              :required="true"
              :rules="[
                { required: true, validator: way, message: '请选择维护方式' },
              ]"
            />

            <van-popup v-model="showGuard" position="bottom">
              <van-picker
                show-toolbar
                :columns="guardColumns"
                @confirm="guardConfirm"
                @cancel="showGuard = false"
              />
            </van-popup>
            <div
              class="line"
              v-if="this.$route.params.type == 3 ? false : true"
            ></div>

            <!-- 需求业态 -->

            <van-field
              readonly
              clickable
              name="formatsValue"
              :border="false"
              :value="formatsValue"
              label="需求业态"
              is-link
              placeholder="请选择"
              input-align="right"
              @click="showFormats = true"
              :required="this.$route.params.type == 3 ? true : false"
              :rules="
                firstCall
                  ? [
                      {
                        required: true,
                        validator: format,
                        message: '请选择需求业态',
                      },
                    ]
                  : []
              "
            />
            <van-popup v-model="showFormats" position="bottom">
              <van-picker
                show-toolbar
                :columns="formatsColumns"
                @confirm="formatsConfirm"
                @cancel="showFormats = false"
              />
            </van-popup>
            <div class="line"></div>
            <!-- 需求面积 -->

            <van-field
              readonly
              clickable
              name="areaValue"
              :border="false"
              :value="areaValue"
              label="需求面积"
              is-link
              placeholder="请选择"
              input-align="right"
              @click="areaFormats = true"
              :required="this.$route.params.type == 3 ? true : false"
              :rules="
                firstCall
                  ? [
                      {
                        required: true,
                        validator: area,
                        message: '请选择需求面积',
                      },
                    ]
                  : []
              "
            />
            <van-popup v-model="areaFormats" position="bottom">
              <van-picker
                show-toolbar
                :columns="areaColumns"
                @confirm="areaConfirm"
                @cancel="areaFormats = false"
              />
            </van-popup>
            <div class="line"></div>
            <!-- 购房意向 -->

            <van-field
              readonly
              clickable
              name="intentionValue"
              :border="false"
              :value="intentionValue"
              label="购房意向"
              is-link
              placeholder="请选择"
              input-align="right"
              @click="intentionFormats = true"
              :required="this.$route.params.type == 3 ? true : false"
              :rules="
                firstCall
                  ? [
                      {
                        required: true,
                        validator: attention,
                        message: '请选择购房意向',
                      },
                    ]
                  : []
              "
            />
            <van-popup v-model="intentionFormats" position="bottom">
              <van-picker
                show-toolbar
                :columns="intentionColumns"
                @confirm="intentionConfirm"
                @cancel="intentionFormats = false"
              />
            </van-popup>
            <div class="line"></div>
            <div class="xiala" v-show="!handleShow">
              <img
                src="../../common/images/progress/xiala.png"
                @click="dropShow"
              />
            </div>
            <div class="handle_show" v-show="handleShow">
              <!-- 家庭结构 -->

              <van-field
                readonly
                clickable
                name="homeValue"
                :border="false"
                :value="homeValue"
                label="家庭结构"
                is-link
                placeholder="请选择"
                input-align="right"
                @click="homeFormats = true"
                :required="false"
              />
              <van-popup v-model="homeFormats" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="homeColumns"
                  @confirm="homeConfirm"
                  @cancel="homeFormats = false"
                />
              </van-popup>
              <div class="line"></div>
              <!-- 年龄段 -->

              <van-field
                readonly
                clickable
                name="ageValue"
                :border="false"
                :value="ageValue"
                label="年龄段"
                is-link
                placeholder="请选择"
                input-align="right"
                @click="ageFormats = true"
                :required="false"
              />
              <van-popup v-model="ageFormats" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="ageColumns"
                  @confirm="ageConfirm"
                  @cancel="ageFormats = false"
                />
              </van-popup>
              <div class="line"></div>
              <!-- 总价预算 -->

              <van-field
                readonly
                clickable
                name="totalValue"
                :border="false"
                :value="totalValue"
                label="总价预算"
                is-link
                placeholder="请选择"
                input-align="right"
                @click="totalFormats = true"
                :required="false"
              />
              <van-popup v-model="totalFormats" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="totalColumns"
                  @confirm="totalConfirm"
                  @cancel="totalFormats = false"
                />
              </van-popup>
              <div class="line"></div>
              <!-- 付款方式 -->

              <van-field
                readonly
                clickable
                name="payValue"
                :border="false"
                :value="payValue"
                label="付款方式"
                is-link
                placeholder="请选择"
                input-align="right"
                @click="showPay = true"
                :required="false"
              />
              <van-popup v-model="showPay" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="payColumns"
                  @confirm="payConfirm"
                  @cancel="showPay = false"
                />
              </van-popup>
              <div class="line"></div>
              <!-- 购买目的 -->

              <van-field
                readonly
                clickable
                name="purposeValue"
                :border="false"
                :value="purposeValue"
                label="购买目的"
                is-link
                placeholder="请选择"
                input-align="right"
                @click="showPurpose = true"
                :required="false"
              />
              <van-popup v-model="showPurpose" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="purposeColumns"
                  @confirm="purposeConfirm"
                  @cancel="showPurpose = false"
                />
              </van-popup>
              <div class="line"></div>
              <!-- 从事行业 -->

              <van-field
                readonly
                clickable
                name="jobValue"
                :border="false"
                :value="jobValue"
                label="从事行业"
                is-link
                placeholder="请选择"
                input-align="right"
                @click="showJob = true"
                :required="false"
              />
              <van-popup v-model="showJob" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="jobColumns"
                  @confirm="jobConfirm"
                  @cancel="showJob = false"
                />
              </van-popup>
              <div class="line"></div>
              <!-- 客户最关注的方面（多选） -->

              <van-field
                readonly
                clickable
                name="mostValue"
                :border="false"
                :value="mostValue"
                label="客户最关注的方面（多选）"
                is-link
                clearable
                placeholder="请选择"
                input-align="right"
                @click="showMost = true"
                :required="false"
                label-width="200"
              />
              <van-popup
                v-model="showMost"
                position="bottom"
                closeable
                @closed="mostConfirm"
              >
                <div class="check_focus">
                  <van-checkbox-group v-model="mostArr">
                    <van-checkbox
                      :name="item"
                      v-for="(item, index) in mostColumns"
                      :key="index"
                      >{{ item }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
              </van-popup>
              <div class="line"></div>

              <div class="no-must">
                <!-- 备注 -->
                <p>备注</p>
                <div class="limit">
                  <textarea v-model="message" :maxlength="120"></textarea>
                  <span>{{ message.length + "/" + 120 }}</span>
                </div>
              </div>
            </div>
          </div>
          <div></div>
          <div class="btn">
            <van-button round block type="info" native-type="submit"
              >确认</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <!-- 推荐成功弹框 -->
    <van-popup
      v-model="showSuccess"
      round
      style="border-radius: 10px;"
      :close-on-click-overlay="false"
    >
      <div class="tip_success">
        <div class="icon">
          <img
            class="success_icon"
            :src="
              require('../../common/images/recommend/recommend_success.png')
            "
          />
          <span>推荐成功</span>
        </div>
        <div class="success_btn" @click="back">我知道了</div>
      </div>
    </van-popup>

    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";

import {
  Field,
  Popup,
  Calendar,
  Picker,
  Checkbox,
  CheckboxGroup,
  Form,
  Toast,
  Icon,
} from "vant";

export default {
  components: {
    "van-field": Field,
    "van-form": Form,
    "van-checkbox": Checkbox,
    "van-checkbox-group": CheckboxGroup,
    "van-popup": Popup,
    "van-icon": Icon,
    "van-calendar": Calendar,
    "van-picker": Picker,
    loading,
  },
  data() {
    return {
      showCalendar: false,
      loadingStatus: false,
      timeValue: "", //日期
      showGuard: false,
      guardColumns: ["去电", "来电", "到访"],
      maintain: "",
      safeguard: "", //维护方式
      showFormats: false,
      formatsColumns: ["住宅", "公寓", "商铺", "办公"],
      formatsValue: "", //业态
      areaFormats: false,
      areaColumns: ["60以下", "60-90", "90-110", "110-140", "140以上"],
      areaValue: "", //面积
      intentionFormats: false,
      intentionColumns: ["A", "B", "C", "D"],
      intentionValue: "", //购房意向
      homeFormats: false,
      homeColumns: ["单身", "两口之家", "三口之家", "三代同堂", "四世同堂"],
      homeValue: "", //家庭结构
      ageFormats: false,
      ageColumns: [
        "20岁以下",
        "21-25",
        "26-30",
        "31-35",
        "36-40",
        "41-50",

        "51-60",

        "60岁以上",
      ],
      ageValue: "", //年龄段
      totalFormats: false,
      totalColumns: [
        "100万以下",
        "100-200",
        "200-300",
        "300-500",

        "500-800",

        "800万以上",
      ],
      totalValue: "", //年龄段
      showPay: false,
      payColumns: ["商业贷款", "公积金贷款", "一次性付款", "分期付款"],
      payValue: "", //维护方式
      showPurpose: false,
      purposeColumns: ["投资", "自住", "为父母购房", "为子女购房"],
      purposeValue: "", //购买目的
      showJob: false,
      jobColumns: [
        "政府机构",
        "IT行业",
        "企业员工",
        "企业高管",
        "文教",
        "公务员",
        "离退休职工",
        "自由职业",
        "建筑/房地产",
        "服务业",
        "医药/卫生",
        "酒店餐饮",
        "私营企业主",
        "个体经营户",
        "其他",
      ],
      jobValue: "", //从事行业
      showMost: false,
      mostColumns: [
        "学区",
        "外立面",
        "居住环境",
        "物业服务",
        "价格",
        "户型面积",
        "交通",
        "开发商品牌",
        "地段",
        "交付时间",
        "商业配套",
        "园区配套",
        "景观园林",
        "装修风格",
        "其他",
      ],
      mostArr: [],
      mostValue: "", //客户最关注的方面（多选）
      flag: true, // 防止重复点击
      showErrTips: false,
      timer: null, // 定时器参数
      timerFlag: null,
      props: { checked: null },
      showPicker: false,
      showSuccess: false, // 推荐成功弹框
      mobile: "",
      message: "", //备注
      handleShow: true,
      firstCall: false,
      isSubmited: false,
    };
  },

  created() {
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');
    document.title = "老带新推荐";
    // 重新注册原生返回按钮事件回调用于限制返回
    this.$nextTick(() => {
      this.$jsBridge.callHandler("dispatchBackBtn");
      this.$jsBridge.registerhandler("onBackPressed", () => {
        // 页面离开时验证
        !this.isSubmited && Toast("请填写跟进详情并提交!");
      });
    });
    this.handleShow = this.$route.params.type == 3 ? false : true;
    this.firstCall = this.$route.params.type == 3 ? true : false;
    if (this.$route.params.tags) {
      let taglist = this.$route.params.tags;
      this.formatsValue = taglist[0].propertyValue;
      this.areaValue = taglist[1].propertyValue;
      this.intentionValue = taglist[2].propertyValue;
      this.homeValue = taglist[3].propertyValue;
      this.ageValue = taglist[4].propertyValue;
      this.totalValue = taglist[5].propertyValue;
      this.payValue = taglist[6].propertyValue;
      this.purposeValue = taglist[7].propertyValue;
      this.jobValue = taglist[8].propertyValue;
      this.mostValue = taglist[9].propertyValue;
      this.message = taglist[10].propertyValue;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 显示原生回退按钮
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');

    document.title = "老带新推荐";
    this.$jsBridge.callHandler("dispatchBackBtn");
    this.$jsBridge.registerhandler("onBackPressed", () => {
      this.$router.back();
    });

    next();
  },
  methods: {
    //下拉显示
    dropShow() {
      this.handleShow = true;
    },
    //返回
    goBack() {},
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return val !== "" ? true : false;
    },
    way(val) {
      return val !== "" ? true : false;
    },
    format(val) {
      return val !== "" ? true : false;
    },
    area(val) {
      return val !== "" ? true : false;
    },
    attention(val) {
      return val !== "" ? true : false;
    },
    //选择日期
    onConfirm(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month > 9 ? month : "0" + month;
      day = day > 9 ? day : "0" + day;

      this.timeValue = `${date.getFullYear()}-${month}-${day}`;

      this.showCalendar = false;
    },
    //维护方式
    guardConfirm(value) {
      switch (value) {
        case "去电":
          this.safeguard = 0;
          break;
        case "来电":
          this.safeguard = 1;
          break;
        case "到访":
          this.safeguard = 2;
          break;
      }
      this.maintain = value;
      this.showGuard = false;
    },
    //需求业态
    formatsConfirm(value) {
      this.formatsValue = value;
      this.showFormats = false;
    },

    //需求面积
    areaConfirm(value) {
      this.areaValue = value;
      this.areaFormats = false;
    },
    //购房意向
    intentionConfirm(value) {
      this.intentionValue = value;
      this.intentionFormats = false;
    },
    //家庭结构
    homeConfirm(value) {
      this.homeValue = value;
      this.homeFormats = false;
    },
    //年龄段
    ageConfirm(value) {
      this.ageValue = value;
      this.ageFormats = false;
    },
    //预算
    totalConfirm(value) {
      this.totalValue = value;
      this.totalFormats = false;
    },
    //付款方式
    payConfirm(value) {
      this.payValue = value;
      this.showPay = false;
    },
    //购买目的
    purposeConfirm(value) {
      this.purposeValue = value;
      this.showPurpose = false;
    },
    //从事行业
    jobConfirm(value) {
      this.jobValue = value;
      this.showJob = false;
    },
    //客户最关注的方面（多选）
    mostConfirm() {
      this.mostValue = this.mostArr.toString();
    },
    // 提交推荐信息
    onSubmit() {
      let params = {
        recommendId: this.$route.params.id,
        connectDate: this.timeValue,
        remark: this.message, // 备注
        isComingCall: this.safeguard, // 0-去电 1-来电 3-首次去电
        tagList: [
          {
            propertyName: "需求业态", //属性名
            propertyValue: this.formatsValue, //属性值
          },
          {
            propertyName: "需求面积", //属性名
            propertyValue: this.areaValue, //属性值
          },
          {
            propertyName: "购房意向", //属性名
            propertyValue: this.intentionValue, //属性值
          },
          {
            propertyName: "家庭结构", //属性名
            propertyValue: this.homeValue, //属性值
          },
          {
            propertyName: "年龄段", //属性名
            propertyValue: this.ageValue, //属性值
          },
          {
            propertyName: "总价预算", //属性名
            propertyValue: this.totalValue, //属性值
          },
          {
            propertyName: "付款方式", //属性名
            propertyValue: this.payValue, //属性值
          },
          {
            propertyName: "购买目的", //属性名
            propertyValue: this.purposeValue, //属性值
          },
          {
            propertyName: "从事行业", //属性名
            propertyValue: this.jobValue, //属性值
          },
          {
            propertyName: "客户最关注的方面（多选）", //属性名
            propertyValue: this.mostArr.join(","), //属性值
          },
          {
            propertyName: "备注信息", //属性名
            propertyValue: this.message, //属性值
          },
        ],
      };
      if (this.$route.params.type == 3) {
        params.isComingCall = 3;
      }
      this.loadingStatus = true;
      this.$api
        .saveCallRecords(params)
        .then(() => {
          this.loadingStatus = false;
          this.isSubmited = true;
          Toast.success("操作成功");
          this.$router.go(-2);
        })
        .catch(() => {
          this.loadingStatus = false;

          Toast.fail("确认失败");
        });
    },
    // 提交成功后返回首页
    back() {
      this.$router.push({
        name: "progressDetail",
      });
      clearTimeout(this.timer);
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend_info {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .head {
    position: fixed;
    top: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 99px;
    padding-right: 20px;
    font-size: 36px;
    width: 100%;
    border-bottom: 1px solid #ddddddff;
    background-color: #fff;
    z-index: 999;
    .back_btn {
      width: 100px;
      height: 99px;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      padding: 10px;
    }
    .title {
      font-weight: 500;
      color: #333333;
      text-align: center;
      width: 100%;
      padding-right: 100px;
    }
  }
  .bg {
    // margin-top: 90px;
    width: 100%;
    height: 248px;
    background-image: url("../../common/images/recommend/info_bg.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .tips {
      color: #fff;
      width: 100%;
      font-size: 28px;
      margin-top: 38px;
      padding: {
        left: 60px;
        right: 60px;
      }
      box-sizing: border-box;
      height: 50px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
  }
  .main {
    flex: 1;
    width: 690px;
    position: relative;
    .table {
      width: 100%;
      height: 900px;
      padding-top: 16px;
      box-sizing: border-box;
      background: #fff;
      position: absolute;
      top: -150px;
      border-radius: 16px;
      .line {
        height: 1px;
        background: #ebedf0;
        margin: {
          left: 30px;
          right: 30px;
        }
      }
      .sex_icon {
        width: 32px;
        height: 38px;
      }
    }
    .btn {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      bottom: -200px;
      padding: {
        left: 16px;
        right: 16px;
      }
      font-size: 32px;
    }
  }
  .tip_success {
    width: 540px;
    height: 730px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #333333;
      .success_icon {
        width: 374px;
        height: 372px;
        margin-bottom: 38px;
      }
    }
    .success_btn {
      width: 452px;
      height: 76px;
      background: #0d9869;
      color: #fff;
      font-size: 28px;
      text-align: center;
      line-height: 76px;
      border-radius: 50px;
    }
  }
  .check_focus {
    margin-top: 100px;
    padding: 30px;
    height: 400px;
    .van-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      .van-checkbox {
        width: 200px;
        margin: 0 0px 30px 30px;
      }
    }
  }
}
</style>
<style lang="scss">
.recommend_info {
  .van-form {
    position: relative;
  }
  .must {
    .van-field--error .van-field__control,
    .van-field--error .van-field__control::placeholder {
      color: rgba(150, 151, 153, 0.5);
    }
    .van-cell {
      height: 102px;
      align-items: center;
    }
  }
  .no-must {
    padding: 0 30px;
    p {
      padding: 30px 0px;

      color: #666666;
    }
    .limit {
      position: relative;
      span {
        position: absolute;
        bottom: 20px;
        right: 20px;
      }
    }

    textarea {
      padding: 10px;
      resize: none;
      height: 218px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #f2f2f2;
      overflow: scroll;
      width: 100%;
    }
    .van-cell {
      padding: 16px;
      display: block;
    }
    .van-field__label {
      width: auto;
    }
    .van-field__value {
      border: 0.5px solid #f2f2f2;
      border-radius: 8px;
      height: 198px;
      margin-top: 24px;
      padding: {
        top: 5px;
        left: 10px;
      }
      box-sizing: border-box;
    }
  }
  .btn {
    margin-bottom: 50px !important;
    .van-button--info {
      background: #0d9869;
      border: none;
    }
  }
  .xiala {
    padding: 40px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      width: auto;
      height: 32px;
    }
  }
}
</style>
